import React from 'react';

// Interruptor accesible (role=switch) que sustituye a los checkboxes en las
// barras de control. Verde (--success) = encendido; gris = apagado; el círculo
// se desliza. Cada handler de uso togglea por su cuenta (lee el estado actual),
// así que onChange se invoca sin argumentos.
const Switch = ({ checked, onChange, disabled, label }) => (
  <button
    type="button"
    role="switch"
    aria-checked={!!checked}
    aria-label={label}
    className="switch"
    disabled={disabled}
    onClick={() => { if (!disabled && onChange) onChange(); }}
  />
);

export default Switch;
